var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(_vm._s(_vm.getDepartment(_vm.params.value) == null ? 'None' : _vm.getDepartment(_vm.params.value).departmentName))])
}
var staticRenderFns = []

export { render, staticRenderFns }